import { SearchTerm } from "./SearchTerm";

const ButtonConfigurationSearch: SearchTerm[] = [
    {
        heading: "Button",
        accessor: "type",
        searchOnName: "settingType.trnName",
        translationKey: "button"
    },
    {
        heading: "Button Text",
        accessor: "name",
        searchOnName: "trnName",
        translationKey: "buttonText"
    },
];

export default ButtonConfigurationSearch;
